import React from 'react';

export function BuildStats(): React.ReactNode {
  const formAppDomain = process.env.FORM_APP_DOMAIN; // eslint-disable-line no-undef
  const builtAt = process.env.ORBIIT_BUILT_AT; // eslint-disable-line no-undef

  if (!builtAt) return null;

  return (
    <div className="absolute bottom-4 left-4">
      <p className="text-xs text-white/20 text-left">
        Built at: {builtAt} UTC

        <br />

        Form App: {formAppDomain}
      </p>
    </div>
  );
}

BuildStats.displayName = 'BuildStats';
